export const LOGO_STYLES = [
  {
    id: 'none',
    text: 'None',
    imagePath: '/none.png',
  },
  {
    id: '3D',
    text: '3D',
    imagePath: '/3d.png',
  },
  {
    id: 'Icon only',
    text: 'ICON ONLY',
    imagePath: '/icon-only.png',
  },
  {
    id: 'Retro',
    text: 'RETRO',
    imagePath: '/retro.png',
  },
  {
    id: 'Futuristic',
    text: 'FUTURISTIC',
    imagePath: '/futuristic.png',
  },
];

export const INDUSTRIES = [
  'Technology',
  'Finance',
  'Healthcare',
  'Retail',
  'Education',
  'Real Estate',
  'Entertainment'
];

export const TONES = [
  'Minimalistic',
  'Bold',
  'Elegant',
  'Playful',
  'Modern',
  'Vintage',
  'Corporate'
];

export const COLORS = [
  'None',
  'Blue',
  'Green',
  'Red',
  'Yellow',
  'Purple',
  'Orange',
  'Pink',
  'Black',
  'White',
  'Gray'
];

export const colorMap: { [key: string]: string } = {
  None: 'transparent',
  Blue: '#0000FF',
  Green: '#00FF00',
  Red: '#FF0000',
  Yellow: '#FFFF00',
  Purple: '#800080',
  Orange: '#FFA500',
  Pink: '#FFC0CB',
  Black: '#000000',
  White: '#FFFFFF',
  Gray: '#808080'
};

export const EXTERNAL_IMAGE_TOOLS = [
  {
    id: 'image-upscale',
    text: 'Upscale Image',
    imagePath: '/test.png',
  },
  {
    id: 'object-remover',
    text: 'Remove Objects',
    imagePath: '/test.png',
  },
  {
    id: 'object-replacer',
    text: 'Replace Objects',
    imagePath: '/test.png',
  },
];
